import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/nextjs/app/[[...slug]]/ContentBlock.jsx");
